<div class="home-header">
    <div class="page">
        <div class="backward" (click)="backToPage()" *ngIf="isBack">
            <img src="assets/icons/arrow-left.svg" />
        </div>
        <h1>{{title}}</h1>
    </div>
    <div class="home-info-user">
        <button class="home-button-question">
            <div class="icon-question"></div>
        </button>
        <div class="home-menu-user card-infos-wrapper" *ngIf="cardInfos" [matMenuTriggerFor]="tdbDmp">
          <div class="icon-card"></div>
          <div class="home-view-container">
            <div class="type-card">Connexion {{ cardInfos.type }}</div>
            <div class="infos-card">{{ cardInfos.user }}</div>
            <div class="infos-card">{{ cardInfos.cabinet }}</div>
          </div>
        </div>
        <div class="home-menu-user" [matMenuTriggerFor]="menu">
          <div class="home-avatar-container">
              <img src="assets/icons/avatar.png" />
          </div>
          <div class="home-view-container">
            <span *ngIf="delegationName" class="delegation" matTooltip="Délégataire : {{delegationName}}" matTooltipPosition="left">Mode Délégation</span>
            <div class="home-user-container">
              <p>{{accountName}}</p>
              <div *ngIf="!this.delegationName || this.delegations.length > 0" class="svg-chevron-down"></div>
            </div>
          </div>
        </div>
        <mat-menu #menu="matMenu" xPosition="before" class="delegationMenu">
          <div class="title-menu">Délégations</div>
          <div *ngIf="delegations && delegations.length > 0">
            <div mat-menu-item *ngFor="let profilDeleg of delegations" (click)="selectDelegation(profilDeleg.delegation.id)">
              <div class="delegation">
                {{ profilDeleg.nom }} {{ profilDeleg.prenom }}
                <div class="avatar">
                  <img style="width: 100%;"src="assets/icons/avatar.png" />
                </div>
              </div>
            </div>
            <mat-divider></mat-divider>
          </div>
          <div *ngIf="delegationName">
            <div (click)="quitDelegation(true)" mat-menu-item>Quitter la délégation en cours</div>
            <mat-divider></mat-divider>
          </div>
          <div (click)="routeToSettings()" *ngIf="!delegationName" mat-menu-item><span class="img settings"></span><span class="sidetext">Informations utilisateur</span></div>
        </mat-menu>
        <mat-menu #tdbDmp="matMenu" xPosition="before" class="delegationMenu">
          <div class="title-menu">Accès WebPS</div>
          <div (click)="routeToDmpTdb()" mat-menu-item><span class="sidetext">Accéder au tableau de bord </span></div>
        </mat-menu>
    </div>
</div>
